import { get } from '../lib/api';

export const getStatusPages = () => {
  return get('status_page', {
    action: 'GET_STATUS_PAGES',
  });
};

export const getStatusPageHttpJobs = (statusPageId) => {
  return get(`status_page/${statusPageId}/http_job`, {
    action: 'GET_STATUS_PAGE_HTTP_JOBS',
    meta: { statusPageId },
  });
};
